/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { Page } from './page-base';
import { iamUtils } from '../main';

export abstract class NonWidgetPage extends Page {
  protected initializePseudoWidgetCommon() {
    this.elements.getFieldsetContainer()?.querySelectorAll('input[type="text"], input[type="password"]').forEach(one => {
      one.addEventListener('blur', e => {
        // when leaving a field, check if it's blank and if so, display the "required" message
        const field = e.target as HTMLInputElement;
        if (!field.value) {
          this.addValidationError(field);
        }
      });
      one.addEventListener('input', e => {
        // when changing a field, clear the validation error if it's not blank
        const field = e.target as HTMLInputElement;
        if (field.value) {
          this.removeValidationError(field);
        }
      });
    });
  }
}
